import {
  HIDE_CAMPAIGN_MEDIA_BUYERS_LOADER,
  SET_CAMPAIGN_MEDIA_BUYER_PROFILE,
  SET_CAMPAIGN_MEDIA_BUYER_USERS_INFO,
  SET_CAMPAIGN_MEDIA_BUYERS_LIST,
  SET_ERROR_CAMPAIGN_MEDIA_BUYER_PROFILE,
  SHOW_CAMPAIGN_MEDIA_BUYERS_LOADER
} from "./actionTypes";

const INIT_STATE = {
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: []
  },
  usersInfo: [],
  loading: false,
  profileData: [],
  isError: false,
  // success: null,
  error: null
}

const CampaignMediaBuyerList = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_CAMPAIGN_MEDIA_BUYERS_LIST:
      return {
        ...state,
        data: action.payload
      }
    case SET_CAMPAIGN_MEDIA_BUYER_USERS_INFO:
      return {
        ...state,
        usersInfo: action.payload
      }
    case SHOW_CAMPAIGN_MEDIA_BUYERS_LOADER:
      return {
        ...state,
        loading: true
      }
    case HIDE_CAMPAIGN_MEDIA_BUYERS_LOADER:
      return {
        ...state,
        loading: false
      }
    case SET_CAMPAIGN_MEDIA_BUYER_PROFILE:
      return {
        ...state,
        profileData: action.payload
      };
    case SET_ERROR_CAMPAIGN_MEDIA_BUYER_PROFILE:
      return {
        ...state,
        isError: action.payload
      };
    default:
      return state
  }
}

export default CampaignMediaBuyerList;
